<template>
  <div :class="[{ app: access_type === 'app' }, 'card', 'video-upload']">
    <div class="step-nav">
      <button class="move-back" @click="goPrev">
        <i class="material-icons">arrow_back_ios</i>
      </button>
    </div>
    <div class="header">
      <h2
        v-html="
          $t('mov_making.step_one2', {
            isInsertEnter: access_type == 'app' ? '<br>' : '',
          })
        "
      ></h2>
    </div>
    <div class="body">
      <p class="information" v-html="$t('mov_making.mov_upload_desc')"></p>
      <div class="type-box">
        <div class="form-box">
          <label v-text="$t('common.t_s_sign_type')"></label>
          <input id="productBox" v-model="product" type="text" readonly />
        </div>
        <div class="form-box">
          <label
            v-html="
              $t('common.t_reg_mov_file', {
                isInsertEnter: access_type === 'app' ? '<br>' : '',
              })
            "
          ></label>
          <div class="file-box">
            <button
              class="button gray"
              :disabled="isSelectDisable"
              @click.prevent="attachFile"
              v-text="$t('movie_list.btn_mov_select')"
            ></button>
            <input
              v-model="fileName"
              type="text"
              class="file-name"
              :disabled="isSelectDisable"
              readonly
            />
            <input
              id="fileInput"
              type="file"
              class="file-input"
              accept=".avi, .mp4, .mov"
              @change="changeFile"
            />
          </div>
        </div>
        <div class="form-box">
          <label
            v-html="
              $t('common.t_name_mov', {
                isInsertEnter: access_type === 'app' ? '<br>' : '',
              })
            "
          ></label>
          <input
            id="mov_name"
            v-model="mov_name"
            type="text"
            maxlength="50"
            @keyup.enter="formSubmit()"
          />
        </div>
        <div v-if="isCheckedAlerts" class="alert-box alert alert-warning">
          <p v-if="checkedAlerts.recommendedSize">
            <strong>{{ `${$t('mov_form.warning')}!` }}</strong>
            {{ $t('mov_form.tip_video_size', { size: '100MB' }) }}
          </p>
          <p v-if="checkedAlerts.recommendedSplitTime">
            <strong>{{ `${$t('mov_form.warning')}!` }}</strong>
            {{ $t('mov_form.tip_video_split_time', { time: 1 }) }}
          </p>
          <p v-if="checkedAlerts.recommendedTime">
            <strong>{{ `${$t('mov_form.warning')}!` }}</strong>
            {{ $t('mov_form.tip_video_time', { time: 15 }) }}
          </p>
        </div>
      </div>
    </div>
    <div class="footer">
      <button
        id="nextBtn"
        class="button normal pointer-none"
        @click.prevent="formSubmit()"
        v-text="$t('movie_send.convert')"
      ></button>
      <button
        id="downloadBtn"
        class="button normal"
        style="display: none"
        @click.prevent="videoDownload()"
        v-text="$t('mov_making.video_download')"
      ></button>
    </div>
    <PopupSpinner :opened="isPopOpend" @popupOff="spinnerOpend" />
  </div>
</template>

<script>
import _ from 'lodash';
import { Common } from '@src/common';
import { API } from '@config/common';
import EventBus from '@utils/bus';
import { getFileExtension, getLanguage } from '@action/util';
import videoData from '@api/video';
import storeVideo from '@store/video';
import PopupSpinner from '@components/PopupSpinner.vue';

export default {
  name: 'mov_upload',
  head: {
    title: {
      inner: 'Video',
      separator: '|',
      complement: 'Smart Solution',
    },
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Edit Video Of Smart Solution',
      },
    ],
  },
  components: {
    PopupSpinner,
  },
  computed: {
    isCheckedAlerts() {
      return _.includes(_.values(this.checkedAlerts), true);
    },
  },
  data() {
    return {
      access_type: '',
      productInfo: {},
      fileData: null,
      fileName: '',
      product: '',
      mov_name: '',
      device_vender: '',
      isPopOpend: false,
      isSelectDisable: false,
      movieStatusProcess: [],
      checkedAlerts: {},
    };
  },
  async created() {
    this.access_type = sessionStorage.getItem('access_type');
    this.productInfo = videoData.product_type_info;
    this.product = this.deviceType();
    this.movieStatusProcess = this.getMovieStatusProcess();
    this.checkedAlerts = this.getDefaultCheckedAlerts();
    const deviceVender = await this.getDeviceVender();
    this.device_vender = deviceVender.vender ?? '';
    this.receiveEventInit();
  },
  destroyed() {
    EventBus.$off('is-opend');
    EventBus.$off('spinner-open');
  },
  methods: {
    receiveEventInit() {
      EventBus.$on('is-opend', (res) => {
        this.isPopOpend = false;

        if (res === 'state_encode') {
          this.isSelectDisable = true;
          document.querySelector('#nextBtn').style.display = 'none';
          const downloadBtn = document.querySelector('#downloadBtn');
          downloadBtn.style.display = 'block';
          downloadBtn.style.background = '#009eff';
          downloadBtn.style.color = '#ffffff';
        }
      });

      EventBus.$on('spinner-open', () => {
        this.isPopOpend = true;
      });
    },
    deviceType() {
      let deviceType = this.$t('mov_making.msg_sign_type');
      deviceType = `${this.productInfo.columns} X ${this.productInfo.rows}${
        this.productInfo.rotate === 'H'
          ? this.$t('common.d_type_hor')
          : this.$t('common.d_type_ver')
      }`;
      return deviceType;
    },
    getDeviceVender() {
      if (sessionStorage.getItem('user_info')) {
        const userInfo = JSON.parse(sessionStorage.getItem('user_info'));
        return this.$store.dispatch('FETCH_DEVICE_VENDER', {
          id: userInfo.user.user_id,
        });
      }

      return {};
    },
    async changeFile(e) {
      e.preventDefault();
      const [selectedFile] = e.target.files || e.dataTransfer.files;
      const { status, checkedAlerts } = await this.getMovieStatus(selectedFile);
      const movieStatusAction = this.getMovieStatusAction(status);
      movieStatusAction({ selectedFile, checkedAlerts });
    },
    getMovieStatus(selectedFile) {
      return new Promise((resolve) => {
        const results = {
          status: 1,
          checkedAlerts: this.getDefaultCheckedAlerts(),
        };

        // Not Found
        if (!selectedFile) {
          results.status = 2;
          resolve(results);
          return;
        }

        const language = getLanguage();
        const fileName = selectedFile.name;
        const fileExt = _.toLower(getFileExtension(fileName));

        // Unsupported Extension
        if (!_.includes(['avi', 'mp4', 'mov'], fileExt)) {
          results.status = 3;
          resolve(results);
          return;
        }

        // Empty
        if (selectedFile.size === 0) {
          results.status = 5;
          resolve(results);
          return;
        }

        // Exceeded Size
        if (language !== 'ja' && selectedFile.size >= Common.MEBIBYTE_600) {
          results.status = 6;
          resolve(results);
          return;
        }

        // Recommended Size
        if (language !== 'ja' && selectedFile.size > Common.MEBIBYTE_100) {
          results.checkedAlerts.recommendedSize = true;
        }

        const URL = window.URL || window.webkitURL;
        const video = document.createElement('video');
        video.src = URL.createObjectURL(selectedFile);

        let count = 0;

        /*
         * Browser에서 지원하지 않는 Video Codec 처리
         * 1. setInterval -> onloadeddata 사용 시 메타 데이터 로드 불가
         * 2. readyState 값 0 출력
         * - Support Codec: AVC1, MP4V ...
         * - Unsupport Codec: FMP4, H264, HVC1, MJPG, MP42, XVID ...
         */
        const i = setInterval(() => {
          const { duration, networkState, readyState } = video;

          // Unknown
          if (count > 30 || (!networkState && !readyState)) {
            clearInterval(i);
            results.status = 4;
            resolve(results);
            return;
          }

          if (
            _.includes([1, 3], networkState) &&
            _.includes([0, 1, 4], readyState)
          ) {
            clearInterval(i);

            // Exceeded Time
            if (language !== 'ja' && duration > Common.MINUTE_60) {
              results.status = 7;
              resolve(results);
              return;
            }

            const isVideoTimeLimit = this.checkVideoTimeLimit();

            // Recommended Split Time
            if (isVideoTimeLimit && duration > 60) {
              if (language !== 'ja') {
                results.checkedAlerts.recommendedSplitTime = true;
              }

              if (
                language === 'ja' &&
                !confirm(this.$t('movie_send.desc_video_time_limit'))
              ) {
                results.status = 9;
                resolve(results);
                return;
              }
            }

            // Recommended Time
            if (
              language !== 'ja' &&
              !isVideoTimeLimit &&
              duration > Common.MINUTE_15
            ) {
              results.checkedAlerts.recommendedTime = true;
            }

            resolve(results);
            return;
          }

          count += 1;
        }, 100);
      });
    },
    getMovieStatusAction(movieStatus) {
      const process = _.filter(
        [...this.movieStatusProcess],
        ([{ status }]) => status === movieStatus,
      );
      const action = process[0][1];
      return action;
    },
    getMovieStatusProcess() {
      const success = ({ selectedFile, checkedAlerts }) => {
        this.fileData = selectedFile;
        this.fileName = selectedFile.name;
        this.checkedAlerts = checkedAlerts;
        document.querySelector('#nextBtn').classList.add('primary');
        document.querySelector('.footer button').style.pointerEvents = 'auto';
      };
      const unsupport = () => {
        alert(this.$t('common.d_mov_api'));
        this.resetFile();
      };
      const unknown = () => {
        alert(this.$t('movie_send.desc_not_file_support'));
        this.resetFile();
      };
      const empty = () => {
        alert(this.$t('common.d_size_mov_error'));
        this.resetFile();
      };
      const exceedSize = () => {
        alert(this.$t('mov_form.limit_video_size', { size: '600MB' }));
        this.resetFile();
      };
      const exceedTime = () => {
        alert(this.$t('mov_form.limit_video_time', { time: 60 }));
        this.resetFile();
      };
      const splitTime = () => this.resetFile();
      const none = () => {};

      return new Map([
        // Success
        [{ status: 1 }, success],
        // Not Found
        [{ status: 2 }, none],
        // Unsupported Extension
        [{ status: 3 }, unsupport],
        // Unknown
        [{ status: 4 }, unknown],
        // Empty
        [{ status: 5 }, empty],
        // Exceeded Size
        [{ status: 6 }, exceedSize],
        // Exceeded Time
        [{ status: 7 }, exceedTime],
        // Split Time
        [{ status: 9 }, splitTime],
      ]);
    },
    resetFile() {
      this.fileData = null;
      this.fileName = '';
      this.checkedAlerts = this.getDefaultCheckedAlerts();
      document.querySelector('#fileInput').value = '';
      document.querySelector('#nextBtn').classList.remove('primary');
      document.querySelector('.footer button').style.pointerEvents = 'none';
    },
    getDefaultCheckedAlerts() {
      return {
        recommendedSize: false,
        recommendedSplitTime: false,
        recommendedTime: false,
      };
    },
    checkVideoTimeLimit() {
      /*
       * AOM39101 전광판 4장 이상 영상 업로드 재생 시간 1분 제한
       * ex. model='AOM39101' AND (columns * rows) > 3
       */
      return (
        this.productInfo.model === 'AOM39101' &&
        this.productInfo.columns * this.productInfo.rows > 3
      );
    },
    formValidator() {
      if (!this.fileData) {
        alert(this.$t('mov_making.msg_upload_mov'));
        return false;
      }

      if (!_.trim(this.mov_name)) {
        alert(this.$t('mov_making.eff_check_movname'));
        document.querySelector('#mov_name').focus();
        return false;
      }

      if (_.size(this.mov_name) > 50) {
        alert(this.$t('mov_form.tip_title_length', { cnt: 50 }));
        document.querySelector('#mov_name').focus();
        return false;
      }

      return true;
    },
    async formSubmit() {
      if (!this.formValidator()) {
        return;
      }

      // zip 확장자 출력 실패 해결
      this.mov_name = this.mov_name.replace(/[$.]/g, '_');

      const formData = new FormData();
      formData.append('product_type_id', videoData.data.product_type_id);
      formData.append('file', this.fileData);
      formData.append('title', this.mov_name);
      formData.append('url', API.CONVERT_CUSTOM);
      formData.append(
        'enable_audio',
        this.device_vender === 'NEXCO-A' ? 'Y' : 'N',
      );

      this.spinnerOpend();
      await this.$store.dispatch('VIDEO_MAKING', formData);
    },
    videoDownload() {
      this.$store.dispatch('VIDEO_DOWNLOAD', {
        data: this.mov_name,
        jobId: storeVideo.state.job_id,
      });
    },
    spinnerOpend() {
      this.isPopOpend = !this.isPopOpend;
    },
    goPrev(type) {
      EventBus.$emit('move-back', type);
    },
    attachFile() {
      document.querySelector('#fileInput').click();
    },
  },
};
</script>

<style scoped lang="scss">
.card.video-upload {
  width: 70%;
  margin: 0 auto;
  background-color: $white;
  position: relative;
  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  -ms-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);

  &.app {
    margin: 12px 0;
    padding: 20px 15px;
  }

  .header {
    h2 {
      margin: 0;
      font-size: 24px;
    }
  }

  .body {
    margin-top: 20px;
    background-color: $white;

    .information {
      font-size: 12px;
      color: $gray-33;
      line-height: 1.5em;
    }

    .form-box {
      display: grid;
      grid-template-columns: 112px auto;
      grid-column-gap: 12px;
      margin-top: 16px;
    }

    .form-box label {
      padding-top: 12px;
      font-size: 12px;
    }

    .form-box input,
    .form-box .button {
      height: 44px;
    }

    .form-box input[type='text'] {
      font-size: 16px;
    }

    .form-box input[type='file'] {
      display: none;
    }

    .form-box .button {
      min-width: 100px;
      padding: 0;
    }

    .form-box .file-box {
      width: 100%;
    }

    .alert-box {
      margin-top: 12px;
    }

    .alert-box p {
      font-size: 11px;
    }

    .alert-box strong {
      font-size: 11px;
    }
  }

  .footer {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .button {
      width: 125px;
      height: 44px;
      border-radius: 3px;
    }

    .primary {
      background-color: $primary;
      color: white;
      text-align: center;
    }

    .button + .button {
      margin-left: 12px;
    }
  }
}

@media (max-width: 480px) {
  .card.video-upload {
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 12px;
  }

  label {
    min-width: 80px;
  }
}

@media (min-width: 480px) {
  .file-box {
    width: 100%;
    display: flex;
    justify-content: flex-start;

    button {
      width: 13%;
      margin-right: 2%;
    }

    .file-name {
      width: 85%;
    }
  }

  label {
    min-width: 100px;
  }
}
</style>
